import { Paper, styled } from "@mui/material";

const UserThemedPaper = styled(Paper)(({ theme }) => ({}));

export default UserThemedPaper;
